import React from 'react'
import { Box, Button } from '@mui/material'
import { useNavigate } from 'react-router-dom'

export default function PrimaryButton({customStyles, text, onClick, link, ...props}) {
    const buttonStyles = {
        fontFamily: 'Poppins, sans-serif', // Use the imported Poppins font
        fontWeight: 'normal', // Regular style
        // fontSize: '1rem', // 14rem font size
        width: '75%'
    }

    const navigate = useNavigate();

    return (
        <Box sx={{display: 'flex', justifyContent: 'center'}}>
            {/* spread the rest of the props onto the MUI component */}
            <Button {...props} style={{...buttonStyles, ...customStyles}} type='submit' variant='contained' color='primary' onClick={onClick}>{text}</Button>
        </Box>
    )
}
